import { useUserController_Me } from '@/services/hooks';

import type { ApiError } from '../shared/errors';
import { useMappedQuery } from '../shared/query';
import { retryUnlessRefused } from '../shared/retry';

import { toAuthSession } from './mappers';
import type { AuthSession } from './types';

export interface SessionQuery {
    session: AuthSession | undefined;
    isLoading: boolean;
    /** A request for the session is running, a retry included. */
    isFetching: boolean;
    error: ApiError | null;
    refetch: () => Promise<unknown>;
}

/** Who is signed in. Shares the `/me` cache entry the profile savers update. */
export function useGetSession(): SessionQuery {
    const query = useMappedQuery(
        // A 401 means nobody is signed in and is not retried; a failure is retried, then the app
        // offers a retry of its own (`sessionUnavailable`).
        useUserController_Me({ refetchOnWindowFocus: false, retry: retryUnlessRefused }),
        toAuthSession
    );
    return {
        session: query.data,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error,
        refetch: query.refetch,
    };
}
